import {
  UPLOAD_FAILURE,
  UPLOAD_SUCCESS,
  UPLOAD_PROGRESS,
  UPLOAD_REQUEST,
  DOWNLOAD_CAR_IMAGES_REQUEST,
  DOWNLOAD_CAR_IMAGES_SUCCESS,
  SET_MAIN,
  SET_MAIN_SUCCESS,
  DELETE,
  DELETE_ALL,
  DELETE_SUCCESS,
  DELETE_ALL_SUCCESS,
} from './constants';

/**
 *
 * @param files
 * @param car
 * @param offer
 * @returns {{files: *, car: *, offer: *, type: *}}
 */
export function uploadRequest(files, car, offer) {
  return {
    type: UPLOAD_REQUEST,
    files,
    car,
    offer,
  };
}

/**
 *
 * @param file
 * @param progress
 * @returns {{file: *, progress: *, type: *}}
 */
export const uploadProgress = (file, progress) => ({
  type: UPLOAD_PROGRESS,
  file,
  progress,
});

/**
 *
 * @param request
 * @returns {{request: *, type: *}}
 */
export const uploadSuccess = response => ({
  type: UPLOAD_SUCCESS,
  response,
});

/**
 *
 * @param error
 * @returns {{type: *, error: *}}
 */
export const uploadError = error => ({
  type: UPLOAD_FAILURE,
  error,
});

export const downloadImages = (carId, carBrand, carModel, imagesType) => ({
  type: DOWNLOAD_CAR_IMAGES_REQUEST,
  carId,
  carBrand,
  carModel,
  imagesType,
});

export const downloadImagesSuccess = () => ({
  type: DOWNLOAD_CAR_IMAGES_SUCCESS
});

export const setMain = imageId => ({
  type: SET_MAIN,
  imageId,
});

export const setMainSuccess = () => ({
  type: SET_MAIN_SUCCESS,
});

export const deleteImage = imageId => ({
  type: DELETE,
  imageId,
});

export const deleteAll = carId => ({
  type: DELETE_ALL,
  carId
});

export const deleteSuccess = imageId => ({
  type: DELETE_SUCCESS,
  imageId
});

export const deleteAllSuccess = imageIds => ({
  type: DELETE_ALL_SUCCESS,
  imageIds
});
